import { useInView } from "@/hooks/use-inview";
import { useEffect, useMemo, useState } from "react";

type InViewComponentProps<T> = {
  list: T[];
  children: (item: T, index: number) => React.ReactNode;
  pageSize?: number;
};

export function InViewComponent<T>({
  list = [],
  children,
  pageSize = 100,
}: InViewComponentProps<T>) {
  const { isVisible, ref } = useInView<HTMLDivElement>({
    threshold: 0,
  });

  const [visibleCount, setVisibleCount] = useState(pageSize);

  useEffect(() => {
    setVisibleCount(pageSize);
  }, [list, pageSize]);

  useEffect(() => {
    if (!isVisible) return;

    setVisibleCount((prev) => {
      if (prev >= list.length) return prev;
      return Math.min(prev + pageSize, list.length);
    });
  }, [isVisible, list.length, pageSize]);

  const visibleList = useMemo(() => {
    return list.slice(0, visibleCount);
  }, [list, visibleCount]);

  const hasMore = visibleCount < list.length;

  return (
    <>
      {visibleList.map((item, index) => children(item, index))}

      {hasMore && (
        <div ref={ref} className="h-1 w-full opacity-0 h-[20px]">
          load more
        </div>
      )}
    </>
  );
}
